import { lazy, Suspense } from 'react'

import { createFileRoute } from '@tanstack/react-router'

import { TableFullSkeleton } from '@/shared/data-table/components/table-skeleton'

const AutomationsTable = lazy(
	() => import('@/features/air/multi-tenant/components/automations-table'),
)

export const Route = createFileRoute(
	'/_dashboard/multi-tenant/_layout/automations',
)({
	component: AutomationsTab,
	pendingComponent: RouteSkeleton,
})

function AutomationsTab() {
	return (
		<Suspense fallback={<TableFullSkeleton rows={10} />}>
			<AutomationsTable />
		</Suspense>
	)
}

function RouteSkeleton() {
	return <TableFullSkeleton rows={10} />
}
